function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1133 13.2072C14.4073 12.9262 14.8703 12.9312 15.1573 13.2202C15.4533 13.5182 15.4493 14.0032 15.1463 14.2952L12.6583 16.7052C12.2683 17.0982 11.6363 17.0982 11.2453 16.7052L8.84526 14.2912C8.54326 13.9872 8.55526 13.4892 8.87326 13.1992C9.16926 12.9302 9.62326 12.9422 9.90526 13.2252L11.2513 14.5802V2.7502C11.2513 2.3362 11.5873 2.0002 12.0013 2.0002C12.4153 2.0002 12.7513 2.3362 12.7513 2.7502V14.5152L14.1133 13.2072ZM5.50146 20.5H18.5015V9.5H16.0015V8H19.0015C19.5535 8 20.0015 8.448 20.0015 9V21C20.0015 21.552 19.5535 22 19.0015 22H5.00146C4.44946 22 4.00146 21.552 4.00146 21V9C4.00146 8.448 4.44946 8 5.00146 8H8.00146V9.5H5.50146V20.5Z",
  fill: "currentColor"
});

function SvgIconImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/iconImport.666784cb.svg";
export { ForwardRef as ReactComponent };